import { Application } from '../BodyWidget/Application';
import { createContext } from 'react';

export default createContext(new Application());
